import PropTypes from 'prop-types'
import React from 'react'
import styled, { keyframes } from 'styled-components'

const blink = keyframes`
  50% {
    opacity: 1;
  }
`

const Container = styled.div`
  display: inline-block;
  /* This non-theme font-size is part of an animated icon effect */
  font-size: 3px; /* stylelint-disable-line scales/font-size */
`

const Dot = styled.span`
  display: inline-block;
  background-color: #969ca4;
  width: 1em;
  height: 1em;
  margin-right: 2px; /* stylelint-disable-line scales/space */
  border-radius: 50%;
  opacity: 0.4;
  animation: ${blink} 1.4s infinite;
  animation-delay: ${props => props.animationDelay};

  &:last-child {
    margin-right: 0;
  }
`

Dot.propTypes = {
  animationDelay: PropTypes.string.isRequired,
}

const Ellipsis = ({ ...props }) => {
  return (
    <Container {...props}>
      <Dot animationDelay="0.3s" />
      <Dot animationDelay="0.6s" />
      <Dot animationDelay="0.9s" />
    </Container>
  )
}

export default Ellipsis
